<!-- eslint-disable vue/require-explicit-emits -->
<template>
  <iRow
    v-bind="rootProps"
  >
    <iCarousel
      :height="myHeight"
      :width="myWidth"
      :style-overrides="{
        carouselScrollerPadding: 'none',
        carouselItemsPadding: myItemsPadding,
        paddingTop: myPadding.top,
        paddingRight: myPadding.right,
        paddingBottom: myPadding.bottom,
        paddingLeft: myPadding.left,
        marginTop: myMargins.top,
        marginRight: myMargins.right,
        marginBottom: myMargins.bottom,
        marginLeft: myMargins.left,
      }"
      :item-min-width="itemMinWidth"
      :item-max-width="itemMaxWidth"
      :gap="myGap"
      :arrows="showArrows"
      :snap="snap"
      :dots="showDots"
      :animations="carouselAnimations"
      :infinite="myInfiniteScroll"
      alignment="center"
    >
      <slot />
    </iCarousel>
  </iRow>
</template>

<script>
import CarouselMixinProduction
  from "%/dynamic-component-editor/standard-elements/layouts/carousel-mixin-production";

export default {
  name: "CarouselContainer",
  // Production twin: exempt from the palette's elementPanelSettings gate.
  production: true,
  mixins: [CarouselMixinProduction],
};
</script>
